module.exports = __webpack_public_path__ + "assets/images/05L-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05L-route-sheet.png
// module id = 1265
// module chunks = 1